<script>
import colors from '@/modules/cells/colors'
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import Popper from 'vue3-popper'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'CommentCreator',
  components: { Popper },
  props: ['driverId'],
  data () {
    return {
      colors: colors,
      comment: {
        Title: '',
        Content: '',
        TextColor: '#222222',
        BackgroundColor: '#FFFFFF',
        sendNotificationOn: '',
        mails: ''
      }
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  methods: {
    addMail (mail) {
      this.comment.mails += mail + ','
    },

    addComment () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const mails = this.comment.mails.split(',')

      const postData = {
        Title: this.comment.Title,
        Content: this.comment.Content,
        TextColor: this.comment.TextColor,
        BackgroundColor: this.comment.BackgroundColor,
        MailNotificationRecipients: mails,
        sendNotificationOn: this.comment.sendNotificationOn,
        dateTime: this.date
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}Comment/Driver/${this.driverId}`, postData, config).then(() => {
        emitter.emit(eventKinds.driverCommentAdded, { driverId: this.driverId })
        Swal.fire('Dodano komentarz', '', 'success')
      }).catch(error => {
        Swal.fire('Nie udało się dodać komentarza', '', 'error')
        console.log(error)
      })
    }
  }
}
</script>

<template>
  <Popper placement="right">
    <div class="text-sm my-2" role="button">
      Dodaj komentarz
    </div>
    <template #content>
      <div style="width: 300px;">
        <input type="text" class="form-control" v-model="comment.Title" placeholder="Tytuł">
        <textarea class="form-control mr-3" v-model="comment.Content" placeholder="Treść" style="margin-top: 5px;"></textarea>

        <div class="text-sm mt-2 user-select-none">
          Kolor tekstu etykiety
          <div>
            <span
              @click="this.comment.TextColor = color"
              v-for="(color, i) in colors"
              :key="i"
              role="button"
              class="mx-1 px-1"
              :style="color === this.comment.TextColor ? `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 3px solid black;` : `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 1px solid black;`"
            ></span>
          </div>
        </div>
        <div class="text-sm mt-2 user-select-none" role="button">
          Kolor tła etykiety
          <div>
            <span
              @click="this.comment.BackgroundColor = color"
              v-for="color in colors"
              :key="color"
              role="button"
              class="mx-1 px-1"
              :style="color === this.comment.BackgroundColor ? `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 3px solid black;` : `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 1px solid black;`"
            ></span>
          </div>
        </div>

        Wyślij przypomnienie:
        <input type="date" class="form-control" ref="selectedDate" v-model="comment.sendNotificationOn">
        Wypisz maile po przecinku:
        <input type="text" class="form-control" v-model="comment.mails" placeholder="Maile">

        <Popper placement="right" >
        <span role="button" class="btn btn-success mt-1">
          Wybierz maile z bazy
        </span>
          <template #content>
            <div v-for="(m, index) in mailings" :key="index" role="button" @click="addMail(m.value)" style="width: 350px">
              {{ m.value }} -> {{ m.name }}
            </div>
          </template>
        </Popper>

        <div style="text-align: center;">
          <button class="btn btn-primary" style="margin-top: 5px; padding: 5px;" @click="addComment">
            Dodaj komentarz
          </button>
        </div>
      </div>
    </template>
  </Popper>
</template>
